import { apiModule } from '@/helpers/utils';
import axios from 'axios';

const casesPrefix = apiModule.CASES;
const icmsPrefix = apiModule.ICMS;
const systemPrefix = apiModule.SYSTEM;
const casesRelatedRequestsPrefix = apiModule.CASES_REQUESTS;
const CancelToken = axios.CancelToken;
const cancelRequests = {};
const requestPrefix = apiModule.REQUESTS;

export default {
    getCaseWithSpecificParty: query =>
        axios.get(`${casesPrefix}/case-with-specific-party`, { params: query }),
    getPegaCaseWithSpecificParty: query =>
        axios.get(`${icmsPrefix}/case-with-specific-party`, { params: query }),
    inquiryCase: query =>
        axios.get(`${icmsPrefix}/inquiry-case`, { params: query }),
    saveCaseRelatedRequest: ({ objectKey, data }) =>
        axios.post(`${casesRelatedRequestsPrefix}/najiz-cases/${objectKey}/related-requests`, data, { overrideErrorHandlingBehaviour: true }),
    saveCassationRequestReply: payload =>
        axios.post(`${casesRelatedRequestsPrefix}/requests/cassation-request/reply`, payload, { overrideErrorHandlingBehaviour: true }),
    savePegaCaseRelatedRequest: ({ objectKey, data }) =>
        axios.post(`${casesRelatedRequestsPrefix}/icms-cases/${objectKey}/related-requests`, data, { overrideErrorHandlingBehaviour: true }),
    updateCaseRelatedRequest: ({ objectKey, data }) =>
        axios.put(`${casesRelatedRequestsPrefix}/najiz-cases-related-requests/${objectKey}`, data, { overrideErrorHandlingBehaviour: true }),
    updatePegaCaseRelatedRequest: ({ objectKey, data }) =>
        axios.put(`${casesRelatedRequestsPrefix}/icms-cases-related-requests/${objectKey}`, data, { overrideErrorHandlingBehaviour: true }),
    updateCaseRelatedRequestStatus: payload =>
        axios.post(`${casesRelatedRequestsPrefix}/najiz-cases-related-requests/${payload.objectKey}/actions`, payload),
    updateCaseRelatedProcedure: ({ objectKey, data }) => axios.put(`${icmsPrefix}/cases/related-procedures/${objectKey}`, data),
    getJudicialProcedureExpirationPeriod: () => axios.get(`${icmsPrefix}/cases/related-procedures/judicial-procedure-expiration-period`),
    getCaseRelatedRequests: objectKey =>
        axios.get(`${casesRelatedRequestsPrefix}/najiz-cases-related-requests/${objectKey}`),
    getPegaCaseRelatedRequests: objectKey =>
        axios.get(`${casesRelatedRequestsPrefix}/icms-cases-related-requests/${objectKey}`),
    uploadAttachment: data =>
        axios.post(`${systemPrefix}/SharePoint/trusted-source/documents`, data),
    getAttachment: documentId =>
        axios.get(`${systemPrefix}/SharePoint/trusted-source/documents?documentId=${documentId}`),
    getRequests: data =>
        axios.get(`${casesRelatedRequestsPrefix}/cases-related-requests`, { params: data }),
    getCases: (payload) => {
        cancelRequests.getCases && cancelRequests.getCases();
        return axios.get(`/ocelot/api/my-cases`, {
            cancelToken: new CancelToken(function executor(cancelFunction) {
                // an executor function receives a cancel function as a parameter
                cancelRequests.getCases = cancelFunction;
            }),
            params: payload,
        });
    },
    getNajizCaseInfo: objectKey => axios.get(`${casesPrefix}/cases/${objectKey}`),
    getIcmsCaseInfo: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}`),
    getNajizCaseUpdates: objectKey => axios.get(`${casesPrefix}/cases/${objectKey}/updates`),
    getIcmsCaseUpdates: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/updates`),
    getNajizCasePartiesDetails: objectKey => axios.get(`${casesPrefix}/cases/${objectKey}/parties-details`),
    getIcmsCasePartiesDetails: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/parties-details`),
    getNajizCaseSessions: objectKey => axios.get(`${casesPrefix}/cases/${objectKey}/sessions`),
    getIcmsCaseSessions: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/sessions`),
    getSessionsByRequestObjectKey: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/sessions-by-request`),
    getNajizCaseJudgments: objectKey => axios.get(`${casesPrefix}/cases/${objectKey}/judgments`),
    getIcmsCaseJudgments: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/judgments-for-portal`),
    getNajizCaseRequests: objectKey => axios.get(`${casesRelatedRequestsPrefix}/najiz-cases/${objectKey}/related-requests`),
    getIcmsCaseRequests: objectKey => axios.get(`${casesRelatedRequestsPrefix}/icms-cases/${objectKey}/related-requests`),
    getWaiverCaseRequests: payload => axios.get(`${casesRelatedRequestsPrefix}/icms-cases/${payload.objectKey}/related-requests-waiver`, { params: payload }),
    getNonCasePartyRequests: objectKey => axios.get(`${casesRelatedRequestsPrefix}/icms-cases/${objectKey}/non-case-party-requests`),
    getNajizCaseDecisions: objectKey => axios.get(`${casesPrefix}/cases/${objectKey}/decisions`),
    getIcmsCaseDecisions: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/decisions`),
    getJudgements: (payload) => {
        cancelRequests.getJudgements && cancelRequests.getJudgements();
        return axios.get(`/ocelot/api/my-judgements`, {
            cancelToken: new CancelToken(function executor(cancelFunction) {
                // an executor function receives a cancel function as a parameter
                cancelRequests.getJudgements = cancelFunction;
            }),
            params: payload,
        });
    },
    getJudgments: ({ caseObjectKey }) =>
        axios.get(`${casesPrefix}/cases/${caseObjectKey}/judgments`),
    getEmirateJudgements: (payload) => {
        cancelRequests.getJudgements && cancelRequests.getEmirateJudgements;
        return axios.get(`${icmsPrefix}/emirate-judgements`, {
            cancelToken: new CancelToken(function executor(cancelFunction) {
                cancelRequests.getEmirateJudgements = cancelFunction;
            }),
            params: payload,
        });
    },
    getPetitionRequestsDetails: (payload) => {
        return axios.get(`${icmsPrefix}/petition-requests`, { params: payload });
    },
    deliverJudgement: payload =>
        axios.post(`${icmsPrefix}/emirate-judgements/deliver`, payload),
    getWaiverOfAppealJudgements: ({ caseObjectKey }) =>
        axios.get(`${icmsPrefix}/cases/${caseObjectKey}/judgements-available-for-waiver-of-appeal`),
    getPegaJudgments: ({ caseObjectKey }) =>
        axios.get(`${icmsPrefix}/cases/${caseObjectKey}/judgments`),
    getJudgementCodeByObjectKey: ({ caseObjectKey }) =>
        axios.get(`${icmsPrefix}/cases/${caseObjectKey}/judgements`),
    isJudgementFromCommercialCourt: judgementCode =>
        axios.get(`${icmsPrefix}/judgements/${judgementCode}/is-commercial-court`),
    getNajizCaseBasicPartiesInfo: ({ objectKey }) => axios.get(`${casesPrefix}/cases/${objectKey}/basic-parties`),
    getIcmsCaseBasicPartiesInfo: ({ objectKey }) => axios.get(`${icmsPrefix}/cases/${objectKey}/basic-parties`),

    getNajizCaseRepresentatives: ({ objectKey }) => axios.get(`${casesPrefix}/cases/${objectKey}/case-representatives`),
    getIcmsCaseRepresentatives: ({ objectKey }) => axios.get(`${icmsPrefix}/cases/${objectKey}/case-representatives`),

    getNajizCasePartiesHaveTravelPreventionDecisions: ({ objectKey }) => axios.get(`${casesPrefix}/cases/${objectKey}/decisions/prevent-travel-decisions`),
    getIcmsCasePartiesHaveTravelPreventionDecisions: ({ objectKey }) => axios.get(`${icmsPrefix}/cases/${objectKey}/decisions/prevent-travel-decisions`),
    getTravelPreventionDecisionRequests: ({ objectKey, decisionNumber }) => axios.get(`${icmsPrefix}/cases/${objectKey}/prevent-travel-decision-requests/${decisionNumber}`, { overrideErrorHandlingBehaviour: true }),

    getICMSCasePartiesHavePrecautionarySeizureOfFundsDecisions: ({ objectKey }) => axios.get(`${icmsPrefix}/cases/${objectKey}/decisions/precautionary-seizure-of-funds-decisions`),

    getTrustedSourceAttachment: documentId => axios.get(`${systemPrefix}/SharePoint/trusted-source/documents?documentId=${documentId}`),

    getNajizWrittenPleadingSession: (caseObjectKey, sessionObjectKey) => axios.get(`${casesPrefix}/cases/${caseObjectKey}/portal/user-remote-argument-sessions?sessionObjectKey=${sessionObjectKey}`),
    getIcmsWrittenPleadingSession: (caseObjectKey, sessionObjectKey) => axios.get(`${icmsPrefix}/cases/${caseObjectKey}/portal/user-remote-argument-sessions?sessionObjectKey=${sessionObjectKey}`),

    getNajizUserCasePartyRoleInCase: caseObjectKey => axios.get(`${casesPrefix}/cases/${caseObjectKey}/case-party-role-in-case`),
    getIcmsUserCasePartyRoleInCase: caseObjectKey => axios.get(`${icmsPrefix}/cases/${caseObjectKey}/case-party-role-in-case`),
    getIcmsUserRoleFromCasePartyRolesInCase: caseObjectKey => axios.get(`${icmsPrefix}/cases/${caseObjectKey}/role-from-case-party-roles-in-case`),

    getNajizPublicReplyRequests: caseObjectKey => axios.get(`${casesPrefix}/cases/${caseObjectKey}/portal/user-remote-argument-sessions/reply-permission`),
    getIcmsPublicReplyRequests: caseObjectKey => axios.get(`${icmsPrefix}/cases/${caseObjectKey}/portal/user-remote-argument-sessions/reply-permission`),

    getDecisions: (payload) => {
        cancelRequests.getDecisions && cancelRequests.getDecisions();
        return axios.get(`/ocelot/api/my-decisions`, {
            cancelToken: new CancelToken(function executor(cancelFunction) {
                // an executor function receives a cancel function as a parameter
                cancelRequests.getDecisions = cancelFunction;
            }),
            params: payload,
        });
    },
    getNajizCaseSession: sessionObjectKey => axios.get(`${casesPrefix}/sessions/${sessionObjectKey}`),
    getIcmsCaseSession: sessionObjectKey => axios.get(`${icmsPrefix}/sessions/${sessionObjectKey}`),

    pushNajizArgumentMessage: payload => axios.post(`${casesPrefix}/cases/${payload.caseObjectKey}/remote-argument-sessions/push-argument-message`, payload),
    pushIcmsArgumentMessage: payload => axios.post(`${icmsPrefix}/cases/${payload.caseObjectKey}/remote-argument-sessions/push-argument-message?courtId=${payload.courtId}`, payload),

    confirmNajizUserAttendance: caseObjectKey => axios.post(`${casesPrefix}/cases/${caseObjectKey}/sessions/register-attendance-user`),
    confirmIcmsUserAttendance: caseObjectKey => axios.post(`${icmsPrefix}/cases/${caseObjectKey}/sessions/register-attendance-user`),

    getNajizLawsuitReplyNoteRequest: caseObjectKey => axios.get(`${casesPrefix}/cases/${caseObjectKey}/lawsuit-reply-note-request`),
    getIcmsLawsuitReplyNoteRequest: caseObjectKey => axios.get(`${icmsPrefix}/cases/${caseObjectKey}/lawsuit-reply-note-request`),

    postNajizRequestPublicReply: payload => axios.post(`${casesPrefix}/cases/${payload.caseObjectKey}/user-remote-argument-sessions/reply-permission`, payload),
    postIcmsRequestPublicReply: payload => axios.post(`${icmsPrefix}/cases/${payload.caseObjectKey}/user-remote-argument-sessions/reply-permission?courtId=${payload.courtId}`, payload),

    validateRequestIssuance: payload => axios.post(`${casesRelatedRequestsPrefix}/cases/${payload.caseObjectKey}/validate-issuing-new-request`, payload),
    getRequestFeesInfo: (payload) => {
        cancelRequests.getRequestFeesInfo && cancelRequests.getRequestFeesInfo();
        return axios.get(`${casesRelatedRequestsPrefix}/cases/${payload.caseObjectKey}/request-type/${payload.requestTypeId}/fees-description?applicantCasePartyId=${payload.applicantCasePartyId}`, {
            cancelToken: new CancelToken(function executor(cancelFunction) {
                // an executor function receives a cancel function as a parameter
                cancelRequests.getRequestFeesInfo = cancelFunction;
            }),
            params: payload.applicantInfo,
        });
    },
    getCaseBills: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/bills`),

    getRequestTypeRequestReasons: requestTypeId => axios.get(`${casesRelatedRequestsPrefix}/request-types/${requestTypeId}/request-reasons`),

    myStatistics: () => axios.get(`${icmsPrefix}/my-statistics`),

    getNajizCaseRequestApplicants: objectKey => axios.get(`${casesPrefix}/cases/${objectKey}/case-request-applicants`),
    getIcmsCaseRequestApplicants: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/case-request-applicants`),
    getCaseRequestApplicantsByJudgement: judgementCode => axios.get(`${icmsPrefix}/cases/judgements/${judgementCode}/case-request-applicants`),
    getCaseRequestApplicant: payload => axios.get(`${icmsPrefix}/cases/${payload.objectKey}/requests/${payload.requestObjectKey}/applicant`),
    getAddRepresentativeApplicants: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/representative-applicants`),

    checkUserHasValidPermission: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/check-user-has-valid-permission`),
    userHasPermissionCaseRelatedRequest: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/user-has-permission-case-related-request`),

    updateCasePartyAttorney: payload =>
        axios.put(`${icmsPrefix}/cases/${payload.caseObjectKey}/update-case-party-attorney`, payload),

    removeAgencyFromCase: payload =>
        axios.put(`${icmsPrefix}/cases/${payload.caseObjectKey}/remove-agency-from-case`, payload),

    getLawsuitSubjectByCaseCode: caseCode => axios.get(`${requestPrefix}/lawsuit-requests/subject?caseCode=${caseCode}`),
    getLawsuitCaseReplies: caseObjectKey => axios.get(`${icmsPrefix}/cases/${caseObjectKey}/lawsuit-reply-response-form`),
    addLawsuitReplyResponseForm: payload => axios.post(`${icmsPrefix}/lawsuit-reply-response-form`, payload),

    validateCaseLawsuitReplyIssuance: caseObjectKey => axios.get(`${icmsPrefix}/cases/${caseObjectKey}/validate-issuing-lawsuit-reply`),

    validateAttorneyAgainstCaseParties: ({ attorneyCode, caseObjectKey, attorneyType = null }) =>
        axios.get(`${icmsPrefix}/cases/${caseObjectKey}/validate-attorney-against-case-parties/${attorneyCode}`,
            { params: { ...(attorneyType ? { attorneyType: attorneyType } : {}) } }),

    validateAttorneyTraineeLawyer: ({ originalAttorneyCode, secondaryAttorneyCode, caseObjectKey, attorneyType = null }) =>
        axios.get(`${icmsPrefix}/cases/${caseObjectKey}/validate-attorney-trainee-lawyer/${originalAttorneyCode}/${secondaryAttorneyCode}`,
            { params: { ...(attorneyType ? { attorneyType: attorneyType } : {}) } }),

    getCaseDocuments: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/documents`),

    validationAttendanceRegister: sessionObjectKey => axios.get(`${icmsPrefix}/cases/${sessionObjectKey}/sessions/validation-attendance-register`),
    addAttendanceRegisterToSession: sessionObjectKey => axios.post(`${icmsPrefix}/cases/${sessionObjectKey}/sessions/add-attendance-registration-to-session`),

    getVideoConference: sessionObjectKey => axios.get(`${icmsPrefix}/cases/${sessionObjectKey}/sessions/video-conference`),
    getCaseJudges: objectKey => axios.get(`${casesRelatedRequestsPrefix}/judges/${objectKey}`),

    getMyTodaySessions: () => axios.get(`${icmsPrefix}/my-today-sessions`),

    getLitigationAbandonmentDefendants: requestId => axios.get(`${icmsPrefix}/get-litigation-abandonment-defendants?requestId=${requestId}`),

    saveLitigationAbandonmentDefendantResponse: payload => axios.put(`${icmsPrefix}/requests/${payload.requestObjectKey}/save-litigation-abandonment-defendant-response`, payload),

    attestDabtByParty: payload =>
        axios.put(`${icmsPrefix}/cases/${payload.caseObjectKey}/sessions/${payload.sessionObjectKey}/session-attendance-attestation/${payload.attestationOption}`, payload),

    GenerateSessionPdf: sessionObjectKey =>
        axios.get(`${icmsPrefix}/generate-session-pdf/${sessionObjectKey}`),

    getCaseInfo: caseObjectKey => axios.get(`${casesRelatedRequestsPrefix}/case-info/${caseObjectKey}`),

    getCaseTypeRequestTypes: requestTypeId => axios.get(`${casesRelatedRequestsPrefix}/${requestTypeId}/request-types`),

    getCaseLawsuitRequests: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/lawsuit-requests`),

    getLawsuitCase: requestObjectKey => axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/subject`),

    IsCaseStoppedOrResume: caseObjectKey => axios.get(`${casesRelatedRequestsPrefix}/cases/${caseObjectKey}/stop-or-resume-status`),

    CheckUserCanAttest: sessionObjectKey =>
        axios.get(`${icmsPrefix}/${sessionObjectKey}/check-user-can-attest`),

    UserCanAttendSession: sessionObjectKey =>
        axios.get(`${icmsPrefix}/${sessionObjectKey}/user-can-attend`),

    sendWaiverOfAppealRequestPartyReply: payload => axios.post(`${casesRelatedRequestsPrefix}/requests/waiver-of-appeal/reply`, payload),

    getWaiverOfAppealRespondents: ({ caseObjectKey, requestObjectKey }) =>
        axios.get(`${casesRelatedRequestsPrefix}/cases/${caseObjectKey}/requests/${requestObjectKey}/waiver-of-appeal/respondents`),

    getJudgementsEligibleForWaiverOfAppeal: ({ caseObjectKey }) =>
        axios.get(`${icmsPrefix}/cases/${caseObjectKey}/judgements-available-for-waiver-of-appeal`),

    getRepresentativesWaiverOfAppeal: ({ caseObjectKey, requestObjectKey }) =>
        axios.get(`${casesRelatedRequestsPrefix}/cases/${caseObjectKey}/requests/${requestObjectKey}/waiver-of-appeal/representatives`),
    getIcmsCaseProcedures: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/related-procedures`),
    getCaseRelatedProcedure: objectKey => axios.get(`${icmsPrefix}/cases/related-procedures/${objectKey}`),
    archiveTheCase: payload => axios.post(`${icmsPrefix}/cases/archive`, payload),
    cancelArchivingTheCase: payload => axios.put(`${icmsPrefix}/cases/unarchive`, payload),
    generateOtp: payload => axios.post(`${icmsPrefix}/OTP/GenerateOtp`, payload),
    validateOtp: payload => axios.post(`${icmsPrefix}/OTP/validateOtp`, payload),
    getNonSpecialityAttachmentAcceptanceCriteria: ({ courtId, caseClassificationId }) => axios.get(`${icmsPrefix}/cases/related-procedures/classifications/acceptance-criteria?courtId=${courtId}&classificationId=${caseClassificationId}`),
    getNearestJudgement: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/nearest-delivery-date`),
    getExecutiveJudgementRespondents: ({ judgementId, casePartyId }) =>
        axios.get(`${icmsPrefix}/executive-judgements/${judgementId}/caseParties/${casePartyId}/respondents`),
    getBankAccountsInfo: ({ casePartyId }) => axios.get(`${icmsPrefix}/caseParties/${casePartyId}/bankAccounts`),
    sendTanfeethRequest: payload => axios.post(`${icmsPrefix}/executive-judgements`, payload),
    getExecutionRequests: ({ judgementId, casePartyId }) =>
        axios.get(`${icmsPrefix}/executive-judgements/${judgementId}/caseParties/${casePartyId}/requests`),
    checkUserHasArchivedCases: () => axios.get(`${icmsPrefix}/cases/check-user-has-archive-cases`),
    getJudgementsByRequestObjectKey: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/judgements-by-request`),
    isRequestExists: requestObjectKey => axios.get(`${casesRelatedRequestsPrefix}/cases/is-request-exists/${requestObjectKey}`),
    getMyArchivedCases: data => axios.get(`${icmsPrefix}/cases/get-my-archived-cases`, { params: data }),
    getPortalTypeOfAppealRequest: caseLifeTimeObjectKey => axios.get(`${icmsPrefix}/cases/${caseLifeTimeObjectKey}/portal-type`),

    getFieldsToEncrypt: id =>
        axios.get(`${casesRelatedRequestsPrefix}/${id}/get-fields-to-encrypt`),
    isValidApplicantForCommercialJudgement: judgementCode =>
        axios.get(`${casesRelatedRequestsPrefix}/judgements/${judgementCode}/is-valid-applicant-for-commercial-judgement`),
    isValidVerdictApplicantForCommercialJudgement: judgementCode =>
        axios.get(`${casesRelatedRequestsPrefix}/judgements/${judgementCode}/is-valid-verdict-applicant-for-commercial-judgement`),
    getExecutiveJudgementRequesters: ({ judgementId, casePartyId, objectKey }) =>
        axios.get(`${icmsPrefix}/executive-judgements/${objectKey}/${judgementId}/caseParties/${casePartyId}/requesters`),
    getAllJudgementRespondents: ({ judgementId }) =>
        axios.get(`${icmsPrefix}/executive-judgements/${judgementId}/respondents`),
    getExecutionBanks: () => axios.get(`${icmsPrefix}/executive-judgements/banks`),

  getIncomingRequestDetails: ({ requestObjectKey }) => axios.get(`${casesRelatedRequestsPrefix}/incoming-requests/${requestObjectKey}`),
  getHearingSessions: objectKey => axios.get(`${icmsPrefix}/cases/${objectKey}/hearing-sessions`),
    getCorrectionDecisions: caseObjectKey =>
        axios.get(`${icmsPrefix}/cases/${caseObjectKey}/correction-decisions`),
  getAppealRequestJudgementJudgementsAndDecisions: appealRequestJudgementObjectKey =>
    axios.get(`${icmsPrefix}/appeal-request-judgements/${appealRequestJudgementObjectKey}/judgements-and-decisions`),
  getCaseSuspensions: caseObjectKey =>
    axios.get(`${icmsPrefix}/cases/${caseObjectKey}/suspensions`),
  getFirstDegreeJudgement: appealJudgementObjectKey =>
    axios.get(`${icmsPrefix}/appeal-judgements/${appealJudgementObjectKey}/first-degree-judgement`),
  getLawsuitReport: caseObjectKey =>
    axios.get(`${icmsPrefix}/cases/${caseObjectKey}/reports/lawsuit`),
  generateLawsuitPaperPdf: caseObjectKey =>
    axios.get(`${icmsPrefix}/cases/${caseObjectKey}/reports/lawsuit-pdf`),
};